import type { CommerceLanding } from '../../../domain/commerce-registry/models/commerce-landing.model';
import { commerceRegistryThemePaletteMock } from './commerce-registry-theme-palette.mock';

const placeholderBanner =
  'https://placehold.co/592x420/111211/e1d5af/png?text=Banner';

/**
 * Optional extras merged **on top of** a Firebase read when `mockEnabled` (wins over the template).
 * Prefer editing {@link createCommerceLandingMock} for demo defaults; use this only to override RTDB
 * without touching the template (e.g. a one-off `commerce_theme` tweak).
 */
export const COMMERCE_LANDING_MOCK_DEV_OVERRIDES: Partial<CommerceLanding> = {};

/** Demo landing payload for dev / when RTDB has no data (mock adapter). */
export function createCommerceLandingMock(slug: string): CommerceLanding {
  const s = slug || 'demo';
  return {
    comercio_slug: s,
    programName: 'Monkey Coins',
    path_banner_lg: placeholderBanner,
    path_banner_md: placeholderBanner,
    path_banner_sm: placeholderBanner,
    logomarca: 'https://larecetaleal.yubasync.com/assets/logo-bdc31858.png',
    commerce_theme: commerceRegistryThemePaletteMock,
    paises: [],
    documentTypes: [],
    generos: [],
    terminos: '',
    data_protection: 'https://landing.leal.co/proteccion-datos',
    privacy_policy: 'https://landing.leal.co/politicas-privacidad',
    terms_conditions: 'https://landing.leal.co/terminos-condiciones',
    otp_habilitado: true,
    /** Dev default OFF so local mock does not call ms-consent unless overridden. */
    ms_consent_habilitado: false,
    /** `false`: show fixed Leal mark; `true`: white-label (hide mark). Same RTDB key `withe_label`. */
    withe_label: false,
    home_view: true,
    home_actions: [
      {
        icon: 'receipt_long',
        label: 'Factura electrónica',
        url: 'http://www.facturaelectronica.com',
      },
      {
        icon: 'restaurant_menu',
        label: 'Ver carta',
        url: 'http://www.micarta.com',
      },
    ],

    ...COMMERCE_LANDING_MOCK_DEV_OVERRIDES,
  };
}
